// PostHog `before_send` scrubber for `$exception` events.
//
// PostHog ships the raw `error.message` to its servers as part of the
// exception payload. Märka's surfaces can throw with user-typed text in
// the message ("Invalid name: Lasse", "Address parse failed for foo@bar.tld"),
// which is PII we don't want stored. The scrubber redacts known patterns
// before the event leaves the browser.
//
// The patterns live in `scrub.ts` because log bodies need the same treatment
// and must not drift from this. See that file for what is redacted and why
// the logs path has to call it explicitly.
//
// This is a coarse safety net, not a full PII filter. The longer-term rule
// is the one codified in `capture-exception.ts`: never put user-typed text
// into `throw new Error("...")` in the first place.

import { scrubPiiText } from "./scrub";

export function scrubExceptionMessage(message: string): string {
  return scrubPiiText(message);
}

interface CaptureEventLike {
  event?: string;
  properties?: Record<string, unknown>;
}

export function beforeSendScrubExceptions<T extends CaptureEventLike | null>(
  event: T,
): T {
  if (event && event.event === "$exception" && event.properties) {
    const message = event.properties.$exception_message;
    if (typeof message === "string") {
      event.properties.$exception_message = scrubExceptionMessage(message);
    }
  }
  return event;
}
